// Carer-parity S3b — context shared between CarerLayout (state owner) and
// the bell rendered in carer page headers (CarerVisitReportPage's
// CarerTopBar rightSlot, plus the inline headers on CarerHomePage and
// CarerVisitDetailPage). Lifts the drawer-open state, the latest
// notifications array, and the derived unread count to one location so
// every carer-side header gains the same affordance for free.

import { createContext, useContext, type JSX, type ReactNode } from "react";
import type { Notification } from "../../components/NotificationsDrawer.js";

export interface CarerNotificationsContextValue {
  items: Notification[];
  unreadCount: number;
  drawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const Ctx = createContext<CarerNotificationsContextValue | null>(null);

interface ProviderProps {
  value: CarerNotificationsContextValue;
  children: ReactNode;
}

export function CarerNotificationsProvider({ value, children }: ProviderProps): JSX.Element {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCarerNotifications(): CarerNotificationsContextValue {
  const ctx = useContext(Ctx);
  if (!ctx) {
    throw new Error("useCarerNotifications must be used inside <CarerNotificationsProvider> (CarerLayout owns the provider)");
  }
  return ctx;
}
